<!-- eslint-disable prettier/prettier -->
<template>
  <v-container fluid>
    <GanttDiagram
      class="mt-6"
      :events="dashboard"
    />
  </v-container>
</template>
<!-- eslint-disable prettier/prettier -->
<script>
    import { GanttDiagram } from "@/components"
    import GanttAdminService from "@/services/GanttAdminService"

    export default {
    components: { GanttDiagram },
    name: "GanttAdmin",
    data() {
        return {
        dashboard: [],
        loading: true
        }
    },
    created() {
        this.init()
    },
    computed: {
        hasTimelineEvents() {
        return this.dashboard.length > 0
        },
    },
    methods: {
        init() {
        this.loading = true
        let companyId = this.$store.getters["app/getCompany"].pk
        GanttAdminService.get_gantt_data(this, companyId)
            .then(r => {
            this.dashboard = r
            })
            .finally(() => {
            this.loading = false
            })
        }
    }
    }
</script>
